import { apiClient } from "../api/client";

// Shown when a signed-in non-admin lands on admin.eminity.com.
// The server's Admin middleware 403s every admin endpoint anyway;
// this page is just the cosmetic surface.
export function NoAccess() {
  const onSignOut = async () => {
    await apiClient.POST("/api/v1/logout", {
      params: { header: { "X-Requested-With": "xhr" } },
    });
    window.location.href = "/login";
  };
  return (
    <main className="min-h-screen flex items-center justify-center px-6">
      <div className="max-w-md text-center">
        <p className="font-mono text-[10px] uppercase tracking-widest text-ink-400 mb-3">
          403 — Forbidden
        </p>
        <h1 className="text-display font-medium text-ink-50 tracking-tightest leading-[1.05] mb-3">
          Admin only
        </h1>
        <p className="text-sm text-ink-300 mb-8 leading-relaxed">
          This account doesn't have admin access. Sign out and try
          again with an admin account, or visit the user app.
        </p>
        <button
          onClick={onSignOut}
          className="inline-flex items-center gap-2 rounded-md bg-accent px-3.5 py-2 text-sm font-medium text-ink-950 hover:bg-accent-glow transition-colors"
        >
          Sign out
        </button>
      </div>
    </main>
  );
}
